(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TNAFrontend", [], factory);
	else if(typeof exports === 'object')
		exports["TNAFrontend"] = factory();
	else
		root["TNAFrontend"] = factory();
})(self, () => {
return 